import $ from 'sbf-design-system/js/jquery';
import svgHelper from 'sbf-design-system/js/svgHelper';

const icons = {
  default: svgHelper.svg_path('sbf-icon-circle-check', 'secondary'),
  success: svgHelper.svg_path('sbf-icon-circle-check', 'secondary'),
  error: svgHelper.svg_path('sbf-icon-alert', 'secondary')
};

const Toast = {
  show: (message, {type = 'success', duration = 3000, htmlMessage = false} = {}) => {
    const icon = icons[type] || icons.default;
    const $toast = $(`
      <div class="sbf-toast sbf-toast--align-center sbf-toast--${type} js-show" role="alert" aria-live="polite" aria-atomic="true">
        <svg class="sbf-toast__icon icon" aria-hidden="true"><use xlink:href="${icon}"></use></svg>
        <div class="sbf-toast__copy"></div>
      </div>
    `);

    if (htmlMessage) {
      $toast.find('.sbf-toast__copy').append(message);
    } else {
      $toast.find('.sbf-toast__copy').text(message);
    }

    $('body').append($toast);
    $toast.addClass('js-show');

    setTimeout(() => {
      $toast.removeClass('js-show');
      // allow time for transitions to run, then remove element
      setTimeout(() => $toast.remove(), 1000);
    }, duration);
  }
}

export default Toast;